import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/telematikInfrastructureSigningMutationParams"
import {
  De_signPrescriptionDocumentWithTelematikInfrastructureInput,
  useDeSignPrescriptionWithTelematikInfrastructureMutation as useDeSignPrescriptionWithTelematikInfrastructureMutationType,
} from "@/modules/patients/detail/prescription/de/services/__generated__/useDeSignPrescriptionWithTelematikInfrastructureMutation.graphql"

const mutation = graphql`
  mutation useDeSignPrescriptionWithTelematikInfrastructureMutation(
    $input: De_signPrescriptionDocumentWithTelematikInfrastructureInput!
  ) {
    de_signPrescriptionDocumentWithTelematikInfrastructure(input: $input) {
      de_Prescription {
        id
        signedAt
        signedBy
        fileId
        ...dePrescriptionFragment
      }
      errors {
        __typename
        ... on Error {
          message
        }
        ... on SignDocumentMutationFailed {
          errorType
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignPrescriptionWithTelematikInfrastructureMutationType>, "variables"> & {
  id: De_signPrescriptionDocumentWithTelematikInfrastructureInput["id"]
}

const useDeSignPrescriptionWithTelematikInfrastructureMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeSignPrescriptionWithTelematikInfrastructureMutationType>(
    mutation,
    TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignPrescriptionWithTelematikInfrastructureMutation }
